export const isPlace = (placeType) =>
  placeType === 'trail' ||
  placeType === 'parkPlace' ||
  placeType === 'place' ||
  placeType === 'google';

export const isAmenity = (placeType) => !isPlace(placeType);
